import { wrappedAnalytics } from './setConfiguration';
export function setProps(eventProps, eventOptions) {
  wrappedAnalytics.setProperties(eventProps, eventOptions);
}